/* eslint-disable @angular-eslint/prefer-on-push-component-change-detection */
import { Component } from '@angular/core';

import { PlatformMediaCustomableName } from '../../../../../shared/db-models/media';

@Component({
  selector: 'app-cms',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  templateUrl: './template.html',
})
export class CmsComponent {
  public activeId = 1;
  public filesNames = Object.values(PlatformMediaCustomableName) as PlatformMediaCustomableName[];
}
